// usePageTracking.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    // Only call gtag if it exists on window (i.e., the script has loaded)
    if (typeof window.gtag !== 'undefined') {
      window.gtag('config', 'G-LVE7D5Q0XY', {
        // This tells GA the "virtual" page path
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);
}

